const followLatestPositionStorageKey = 'mapapal.followLatestPosition'
const showLivePositionInfoStorageKey = 'mapapal.showLivePositionInfo'

export function readFollowLatestPosition(
  storage: Pick<Storage, 'getItem'> = localStorage,
): boolean {
  return storage.getItem(followLatestPositionStorageKey) !== 'false'
}

export function storeFollowLatestPosition(
  enabled: boolean,
  storage: Pick<Storage, 'setItem'> = localStorage,
): void {
  storage.setItem(followLatestPositionStorageKey, String(enabled))
}

export function readShowLivePositionInfo(
  storage: Pick<Storage, 'getItem'> = localStorage,
): boolean {
  return storage.getItem(showLivePositionInfoStorageKey) !== 'false'
}

export function storeShowLivePositionInfo(
  enabled: boolean,
  storage: Pick<Storage, 'setItem'> = localStorage,
): void {
  storage.setItem(showLivePositionInfoStorageKey, String(enabled))
}
